/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Text ,Flex } from "@chakra-ui/react";

import LedgerTable from "./ledgerTable";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import GetAddress from "components/GetAddress";
import { useSelector } from "react-redux";


const VendorLedgerPdf = ({ledgerData ,total,vendorDetail,dateRenge, startYear, endYear,organizationData}) => {
  const logoData = useSelector((state) => state.logoData);
  const logoUrl = logoData?.downloadUrl || "";

  return (
    <>
            <div className="details-container">
              <Box className="ledger-template" >
            <Flex align="center" direction="column" className="ledger-pdf-logo mb-0">
                  <img src={logoUrl} alt="logo" />
            </Flex>
              <Box
                  display="flex"
                  className="ledger-header ledger-pdf-header"
                  justifyContent="space-between"
                >
                  <div className="header-left header-box">
                    <Text className="title">{organizationData?.name}</Text>
                    <Text className="address">
                    <GetAddress address={organizationData?.add}/>
                    </Text>
                  </div>

                  <div className="header-right header-box mt-3">
                    <Text className="title">{vendorDetail?.name}</Text>
                    <Text className="address">
                      <GetAddress address={vendorDetail?.blAd}/>

                    </Text>
                  </div>
                </Box>
                <Box className="ledger-main" >
                  
                <Text className="ledger-date">Date: {dateTimeFormat(dateRenge?.startDate ? dateRenge?.startDate :`${startYear}-04-01`)} to {dateTimeFormat(dateRenge?.endDate ? dateRenge?.endDate :`${endYear}-03-31`)}</Text>
                <Box className="ledger-table ledger-pdf-table">
                       <LedgerTable ledgerData={ledgerData} total={total}/>
                    </Box>
                </Box>
              </Box>
            </div>
         
    </>
  );
};

export default VendorLedgerPdf;
